// extracted by extract-css-chunks-webpack-plugin
module.exports = {"min-width-0":"NELEDo","flex-shrink-0":"_1JuHru"};